export default __webpack_public_path__ + "static/media/testSeriesIcon.88ca1f1f.svg";